<template>
<el-card class="box-card" >
  <el-collapse-item  name="3">
    <template slot="title">
      <span class="title">{{$t('message.title.affectedModel')}}</span>
    </template>
  <el-collapse-transition>
    <div class="right" >
      <template>
        <el-table stripe :data="affectData" style="width: 100%;" max-height="290" border>
          <template v-for="(item,index) in tableHead">
            <el-table-column :prop="item.id" :label="item.name" :key="index" width="200"></el-table-column>
          </template>
        </el-table>
      </template>
    </div>
  </el-collapse-transition>
  </el-collapse-item>
</el-card>
</template>

<script>
export default {
  props:['affectData','tableHead']
}
</script>

<style  scoped>
.title{
  border-left: 8px solid var(--themeColor);
  padding-left: 12px;
  font-size: 18px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}
  .affect{
    width: 100%;
    max-height: 300px; 
    overflow: auto;
  }
</style>